import styled from '@emotion/styled';

export const AppContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    max-width: 1000px;
    width: 100%;
    box-sizing: border-box;

    @media (max-width: 768px) {
        width: 100%;
        padding: 0;
    }
`;
